import { Empty, Skeleton } from "antd";
import PropTypes from "prop-types";

function CarDetailSection({
    title,
    children,
    loading = false,
    empty = false,
    emptyDescription,
    headerAction,
    skeletonRows = 3,
    noPadding = false,
    className = "",
    embedded = false,
}) {
    const shellClass = embedded
        ? "bg-transparent"
        : "mt-4 rounded-[1.3rem] bg-white";

    return (
        <div className={`flex flex-col overflow-y-auto ${shellClass} ${className}`}>
            {(title || headerAction) && (
                <div className="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-[#f0f0f0] px-4 py-5">
                    {title && <span className="fontSemi text-[1.1rem]">{title}</span>}
                    {headerAction}
                </div>
            )}

            {loading && (
                <div className="p-8">
                    <Skeleton active paragraph={{ rows: skeletonRows }} />
                </div>
            )}

            {!loading && empty && (
                <div className="p-8">
                    <Empty description={emptyDescription} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            )}

            {!loading && !empty && (
                <div className={noPadding ? undefined : "px-4 pb-4"}>{children}</div>
            )}
        </div>
    );
}

CarDetailSection.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
    loading: PropTypes.bool,
    empty: PropTypes.bool,
    emptyDescription: PropTypes.string,
    headerAction: PropTypes.node,
    skeletonRows: PropTypes.number,
    noPadding: PropTypes.bool,
    className: PropTypes.string,
    embedded: PropTypes.bool,
};

export default CarDetailSection;
